import React from 'react';
import styles from '../css/ActionTile.module.css';

export default function ActionTile({ icon = 'doc', title, rightLinkLabel, onRightLinkClick, onClick }) {
  const tileClass = onClick ? `${styles.tile} ${styles.clickable}` : styles.tile;
  return (
    <div className={tileClass} onClick={onClick} role={onClick ? 'button' : undefined}>
      <div className={styles.left}>
        <span className={styles.icon} aria-hidden>
          {icon === 'doc' ? '📄' : '📝'}
        </span>
        <span className={styles.title}>{title}</span>
      </div>
      {rightLinkLabel && (
        <button type="button" className={styles.linkBtn} onClick={onRightLinkClick}>
          {rightLinkLabel}
        </button>
      )}
    </div>
  );
}
